import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserKey } from '../user/user.hooks';
import type { WorkspaceItem } from '../user/user.types';
import { ListItemAction, TeamsService, UsersService } from '../../generated';
import { useTeamKey } from '../team/team.hooks';

export const useRemovePaymentGateway = (workspace?: WorkspaceItem) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (id: string) => {
            if (!workspace || workspace.individual) {
                const response = await UsersService.updatePaymentGatewayUsers({
                    body: {
                        items: [{ id, action: ListItemAction.REMOVE }],
                    },
                });

                if (!response.data)
                    throw new Error(`Failed to remove payment gateway`);

                return response.data;
            }
            const response = await TeamsService.updatePaymentGatewayTeams({
                body: {
                    items: [{ id, action: ListItemAction.REMOVE }],
                },
                path: {
                    team_id: workspace.id,
                },
            });

            if (!response.data)
                throw new Error(`Failed to remove payment gateway`);

            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [useUserKey] });
            queryClient.invalidateQueries({ queryKey: [useTeamKey] });
        },
    });
};
